//react
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';

//css
import './alertWindow.css';
import { getEmergencyList } from '../../../service/log/alertLogService_test';
import AlertWindowItem from './alertWindowItem';
import { getAlertList, getEventAlarmList } from '../../../service/log/alertLogService';
const AlertWindow = ({ conn }) => {
  const [dataSource, setDataSource] = useState([]);

  const [today, setToday] = useState('');

  //100초마다 alertList
  const refreshAlertList = () => {
    setTimeout(() => {
      setToday(new Date());
    }, 600000);
    getEventAlarmList(conn)
      .then(response => {
        const result = response.filter(item => item.eventTypeTerm !== '일일현황알림');
        setDataSource(result);
      })
      .catch(error => console.log('getEventAlarmList Error', error));
  };

  useEffect(() => {
    refreshAlertList();
  }, [today]);

  return (
    <div>
      {dataSource.map((item, index) => (
        <AlertWindowItem item={item} index={index} today={today}></AlertWindowItem>
      ))}
    </div>
  );
};

export default AlertWindow;
